import { Link } from 'react-router-dom';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '@/context/CookieConsentContext';

export default function CookieBanner() {
  const { t } = useTranslation('cookies');
  const { consent, accept, reject, hydrated } = useCookieConsent();
  const reduce = useReducedMotion();

  const visible = hydrated && consent === null;

  const body = (
    <div
      role="region"
      aria-label={t('settings')}
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#111827] text-[#F7F5F0] border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,0.15)]"
      data-testid="cookie-banner"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 md:py-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
        <p className="text-sm leading-relaxed text-[#F7F5F0]/90 flex-1">
          {t('message')}{' '}
          <Link
            to="/privacy"
            className="text-[#B08D57] underline-offset-2 hover:underline transition-colors"
            data-testid="cookie-banner-privacy-link"
          >
            {t('privacyLink')}
          </Link>{' '}
          {t('messageTail')}
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={reject}
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium border border-[#F7F5F0]/40 text-[#F7F5F0] hover:border-[#B08D57] hover:text-[#B08D57] transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B08D57] whitespace-nowrap"
            data-testid="cookie-banner-reject"
          >
            {t('reject')}
          </button>
          <button
            type="button"
            onClick={accept}
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium border border-[#F7F5F0]/40 text-[#F7F5F0] hover:border-[#B08D57] hover:text-[#B08D57] transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B08D57] whitespace-nowrap"
            data-testid="cookie-banner-accept"
          >
            {t('accept')}
          </button>
        </div>
      </div>
    </div>
  );

  if (reduce) {
    return visible ? body : null;
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="cookie-banner-wrap"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.22, ease: 'easeOut' }}
        >
          {body}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
